import { Select, SelectProps } from "antd";
import { useTranslation } from "react-i18next";

import { countries } from "@/utils/country";
import SText from "@/styles/SText";
import { CellSelectWrap } from "./style";

interface CountrySelectProps extends SelectProps {
  value?: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
}

const CountrySelect = ({
  value,
  onChange,
  readOnly,
}: CountrySelectProps) => {
  const { t } = useTranslation();

  if (readOnly) {
    return <SText text={countries.find(item => item.code === value)?.name ?? ''} />;
  }

  return (
    <CellSelectWrap>
      <Select
        value={value}
        disabled={readOnly}
        onChange={onChange}
        showSearch
        style={{ width: "100%" }}
        placeholder={t("components.plCountry")}
        filterOption={(input, option) =>
          (option?.name ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={countries}
        fieldNames={{ label: "name", value: "code" }}
        labelRender={(info) => (
          <SText
            text={info.label as string}
            style={{ width: readOnly ? "100%" : 80 }}
          />
        )}
        popupMatchSelectWidth={false}
        optionRender={(info) => (
          <SText text={info.data.name} style={{ width: 200 }} />
        )}
      />
    </CellSelectWrap>
  );
};

export default CountrySelect;
